import React, { useState } from 'react'
import { Modal, Select, DatePicker, TimePicker, Input } from 'antd'
import { leagueStaffStore } from 'state/league/leagueStaff'
import { infoMessage } from 'api/global'
import closeIcon from 'assets/Images/close.svg'

const { TextArea } = Input
const { Option } = Select

const RequestMentorModal: React.FC = () => {
  const { requestMentorModal, setRequestMentorModal } = leagueStaffStore(
    store => ({
      requestMentorModal: store.requestMentorModal,
      setRequestMentorModal: store.setRequestMentorModal,
    }),
  )

  const [position, setPosition] = useState<string | undefined>()
  const [notes, setNotes] = useState('')

  const close = () => setRequestMentorModal(false)

  const handleSubmit = () => {
    infoMessage('Mentor request submitted — coming soon')
    close()
  }

  return (
    <Modal
      open={requestMentorModal}
      onCancel={close}
      footer={null}
      width={520}
      centered
      maskClosable={false}
      className="custom-common-modal"
    >
      <div className="px-15px modal-body">
        <div className="flex-center pt-20px justify-between">
          <h2 className="w-600 text-24">Request a Mentor</h2>
          <img
            src={closeIcon}
            alt="close"
            onClick={close}
            className="close pointer"
          />
        </div>

        <div className="mt-30px modal-content">
          <div className="staff-form-group">
            <label className="staff-form-label">Position</label>
            <Select
              placeholder="Select position"
              value={position}
              onChange={setPosition}
              className="staff-form-select"
            >
              <Option value="referee">Referee</Option>
              <Option value="score-keeper">Score Keeper</Option>
              <Option value="coach">Coach</Option>
              <Option value="mentor">Mentor</Option>
            </Select>
          </div>

          <div className="staff-form-group">
            <label className="staff-form-label">Date</label>
            <DatePicker className="staff-form-picker" />
          </div>

          <div className="staff-form-row">
            <div className="staff-form-group">
              <label className="staff-form-label">From</label>
              <TimePicker
                format="h:mm a"
                use12Hours
                className="staff-form-picker"
              />
            </div>
            <div className="staff-form-group">
              <label className="staff-form-label">To</label>
              <TimePicker
                format="h:mm a"
                use12Hours
                className="staff-form-picker"
              />
            </div>
          </div>

          <div className="staff-form-group">
            <label className="staff-form-label">Notes</label>
            <TextArea
              rows={3}
              placeholder="Add any notes..."
              value={notes}
              onChange={e => setNotes(e.target.value)}
              className="staff-form-textarea"
            />
          </div>

          <div className="staff-modal-footer">
            <button className="att-confirm-cancel-btn" onClick={close}>
              Cancel
            </button>
            <button className="button btn-primary" onClick={handleSubmit}>
              Submit Request
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default RequestMentorModal
